"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const match_sorter_1 = require("match-sorter");
const SvgIcon_1 = __importDefault(require("../../../components/SvgIcon"));
const buildDebouncedFunction_1 = __importDefault(require("../../../shared/buildDebouncedFunction"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const style_1 = __importDefault(require("./style"));
const PickerViewRenderer = ({ items, value, placeholder, arrowsEnabled, searchEnabled, style, onChange, }) => {
    var _a;
    const { Render } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const [open, setOpen] = (0, react_1.useState)(false);
    const [searchField, setSearchField] = (0, react_1.useState)('');
    const [search, setSearch] = (0, react_1.useState)('');
    const frameStyle = (0, react_1.useMemo)(() => ({
        width: style.width,
        height: style.height,
        backgroundColor: style.background,
        borderStyle: style.borderStyle,
        borderTopWidth: style.borderTopWidth,
        borderRightWidth: style.borderRightWidth,
        borderBottomWidth: style.borderBottomWidth,
        borderLeftWidth: style.borderLeftWidth,
        borderTopRightRadius: style.borderTopRightRadius,
        borderTopLeftRadius: style.borderTopLeftRadius,
        borderBottomRightRadius: style.borderBottomRightRadius,
        borderBottomLeftRadius: style.borderBottomLeftRadius,
        marginBottom: style.marginBottom,
        marginLeft: style.marginLeft,
        marginRight: style.marginRight,
        marginTop: style.marginTop,
    }), [style]);
    const labelStyle = (0, react_1.useMemo)(() => ({
        paddingLeft: style.paddingLeft,
        paddingRight: style.paddingRight,
        fontWeight: style.fontWeight,
        fontStyle: style.fontStyle,
        color: style.color,
        fontSize: style.fontSize,
    }), [style]);
    const filteredItems = (0, react_1.useMemo)(() => {
        const newItems = search ? (0, match_sorter_1.matchSorter)(items, search, { keys: ['label'] }) : items;
        return ([
            {
                label: placeholder,
                value: '',
            },
            ...newItems,
        ]);
    }, [items, search, placeholder]);
    const pickerPlaceholder = ((_a = items.find((item) => item.value === value)) === null || _a === void 0 ? void 0 : _a.label) || placeholder;
    const debouncedSetSearch = (0, react_1.useMemo)(() => (0, buildDebouncedFunction_1.default)(200, setSearch), []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Render.TouchableOpacity, { style: Object.assign(Object.assign({}, style_1.default.pickerFrame), frameStyle), onPress: () => {
                setSearch('');
                setSearchField('');
                setOpen(true);
            } },
            react_1.default.createElement(Render.Text, { style: Object.assign(Object.assign({}, style_1.default.pickerLabel), labelStyle) }, pickerPlaceholder),
            arrowsEnabled && (react_1.default.createElement(Render.View, null,
                react_1.default.createElement(Render.View, null,
                    react_1.default.createElement(SvgIcon_1.default, { name: "arrow_drop_up", size: 25, color: "gray" })),
                react_1.default.createElement(Render.View, null,
                    react_1.default.createElement(SvgIcon_1.default, { name: "arrow_drop_down", size: 25, color: "gray" }))))),
        open && (react_1.default.createElement(Render.Modal, { visible: true, animationType: "fade", transparent: true },
            react_1.default.createElement(Render.TouchableOpacity, { onPress: () => setOpen(false), style: style_1.default.modalFrame },
                react_1.default.createElement(Render.SafeAreaView, { style: style_1.default.modalFrame },
                    react_1.default.createElement(Render.View, { style: style_1.default.modalContent },
                        searchEnabled && (react_1.default.createElement(Render.TouchableOpacity, { style: {
                                width: '100%',
                            } },
                            react_1.default.createElement(Render.TextInput, { value: searchField, placeholder: "Search value", style: style_1.default.searchInput, isFocused: false, placeholderTextColor: "#b0bec5", onChangeText: (newValue) => {
                                    setSearchField(newValue);
                                    debouncedSetSearch(newValue);
                                }, onFocus: (event) => {
                                    event.preventDefault();
                                } }))),
                        react_1.default.createElement(Render.FlatList, { data: filteredItems, refreshing: false, style: style_1.default.listFrame, renderItem: ({ index, item }) => (react_1.default.createElement(Render.TouchableOpacity, { key: index, style: style_1.default.itemFrame, onPress: () => {
                                    onChange(item.value);
                                    setOpen(false);
                                } },
                                react_1.default.createElement(Render.Text, { style: style_1.default.itemLabel }, item.label))) }))))))));
};
exports.default = PickerViewRenderer;
